import { Box, Chip, Tooltip } from "@mui/material";
import EditNoteIcon from '@mui/icons-material/EditNote';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import { LineaFichajes } from "../../utils/Jornada";

// En el móvil, el detalle sale con un toque normal (no hace falta dejar el dedo) y se queda unos segundos
const alTocar = { enterTouchDelay: 0, leaveTouchDelay: 5000 };

// Un elemento de los fichajes de un día («Entrada 9:02», «Pausa 11:00–11:15»), con su marca: corregido por el admin (con
// el original, quién y por qué al pasar el ratón) u hora declarada.
const ChipFichaje = ({ linea, size = 'medium' }: { linea: LineaFichajes; size?: 'small' | 'medium' }) => {
    if (linea.correcciones.length > 0) {
        return (
            <Tooltip {...alTocar} title={<Box>{linea.correcciones.map((t, i) => <div key={i}>{t}</div>)}</Box>}>
                <Chip size={size} label={linea.texto} variant="outlined" icon={<AdminPanelSettingsOutlinedIcon />} />
            </Tooltip>
        );
    }
    if (linea.declarada) {
        return <Tooltip {...alTocar} title="Hora declarada"><Chip size={size} label={linea.texto} variant="outlined" icon={<EditNoteIcon />} /></Tooltip>;
    }
    return <Chip size={size} label={linea.texto} variant="outlined" />;
};

// Un fichaje anulado por el admin: tachado, con quién y por qué al pasar el ratón
export const ChipAnulado = ({ texto, detalle, size = 'medium' }: { texto: string; detalle: string; size?: 'small' | 'medium' }) => (
    <Tooltip {...alTocar} title={detalle}>
        <Chip size={size} label={texto} variant="outlined" sx={{ textDecoration: 'line-through', color: 'text.disabled' }} />
    </Tooltip>
);

export default ChipFichaje;
